// Съобщение с бутон („Отчет №20 е разнесен · Виж документа"). antd `message`
// няма бутон, затова е `notification` долу в центъра (6 s), вдигнат над
// лепкавите футъри („Разнеси", „Запиши") с половин safe-area отстъп.
// Статичният `notification.*` не рендира под React 19 — идва от App.useApp().
import { App } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useCallback } from "react";

type ActionToast = {
  text: string;
  actionLabel?: string;
  onAction?: () => void;
};

export const useActionToast = () => {
  const { notification } = App.useApp();
  return useCallback(
    ({ text, actionLabel, onAction }: ActionToast) => {
      const key = `inv-toast-${Date.now()}`;
      notification.open({
        key,
        placement: "bottom",
        duration: 6,
        closeIcon: null,
        icon: <CheckCircleFilled className="text-ok-solid" />,
        // над футъра с бутоните + половин safe-area
        className: "!mb-[calc(64px+env(safe-area-inset-bottom,0px)*0.5)]",
        message: (
          <span className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm leading-[1.4] text-ink">
            <span>{text}</span>
            {actionLabel && onAction && (
              <button
                type="button"
                onClick={() => {
                  notification.destroy(key);
                  onAction();
                }}
                className="cursor-pointer whitespace-nowrap border-none bg-transparent p-0 text-sm font-semibold text-brand-deep-ink hover:underline"
              >
                {actionLabel}
              </button>
            )}
          </span>
        ),
      });
    },
    [notification],
  );
};

export default useActionToast;
